import { usePaymentMethodState } from "./";
import CreditCardEntry from "./CreditCardEntry";

export default function AddPaymentMethodCreditCardEntry({
  show,
  setInputErrors,
  shouldClearDisplayMessages,
  setShouldClearDisplayMessages,
  initialPaymentType,
  ...props
}) {
  const {
    submitting,
    deleting,
    setState,
    isAlreadyExisting,
    ID,
    zip,
    paymentMethodID,
    cardType,
    paymentType,
    expirationMonth,
    expirationYear,
    last4,
    owner,
    accountHolderName,
  } = usePaymentMethodState();

  const ccData = {
    ID,
    zip,
    paymentMethodID,
    cardType,
    expirationMonth,
    expirationYear,
    last4,
    owner,
    accountHolderName,
  };

  const setPaymentMethodTokenInfo = (info) => {
    if (!info.error) {
      setState({ ...info, ccReadyToSubmit: true });
    } else {
      setState({ submitting: false });
    }
  };

  const shouldRender = () => {
    // we always show this credit card form when adding a new PM,
    // since adding a new bank account does not use this view
    // (it just opens the Plaid modal)
    return (
      (paymentType === "card" || !isAlreadyExisting) &&
      initialPaymentType !== "bank"
    );
  };

  if (!shouldRender()) return null;

  return (
    <CreditCardEntry
      getPaymentMethodTokenTrigger={submitting}
      setPaymentMethodTokenInfo={setPaymentMethodTokenInfo}
      show={show}
      setInputErrors={setInputErrors}
      shouldClearDisplayMessages={shouldClearDisplayMessages}
      setShouldClearDisplayMessages={setShouldClearDisplayMessages}
      isAlreadyExisting={isAlreadyExisting}
      submitting={submitting || deleting}
      {...props}
      {...ccData}
    />
  );
}
